import { toPluralized } from '~/utils/pluralize';
import DallasText from '../../Dallas/Text/DallasText';
import { DallasTextVariant } from '../../Dallas/types/typography';

export interface CommonFormattedMeasurementProps {
  measurement: number;
  textVariant?: DallasTextVariant;
  formatter?: (measurement: number) => string;
}

interface Props extends CommonFormattedMeasurementProps {
  formatter: (measurement: number) => string;
  unitName: string;
  unitAbbr: string;
  unitPluralName?: string;
  unitPluralAbbr?: string;
}

export default function FormattedMeasurement({
  textVariant,
  formatter: format,
  measurement,
  unitName,
  unitAbbr,
  unitPluralName,
  unitPluralAbbr,
}: Props) {
  return (
    <DallasText variant={textVariant}>
      {format(measurement)}&nbsp;
      <abbr title={toPluralized(measurement, unitName, unitPluralName)}>
        {toPluralized(measurement, unitAbbr, unitPluralAbbr)}
      </abbr>
    </DallasText>
  );
}
